// Global keyboard modality flag. While a modal dialog is up, every
// useKey listener that hasn't opted in (whenModal) goes inert — a single
// choke point instead of per-hook guards.
//
// A module-level flag, not React state: useKey handlers consult it at
// event time, and the Stage (the only writer) syncs it from the window
// manager in an effect. Deliberately not reactive — nothing re-renders
// on modality; things just stop hearing keys.

let active = false;

export function setModalGate(v) {
  active = !!v;
}

export function modalGateActive() {
  return active;
}
